import React from 'react'
import ReactApexChart from 'react-apexcharts'
import {useThemeMode} from '../../../../_metronic/partials'
import {NoDataPage} from '../../resources/components/NoDataPage'

const OverviewGraph = ({series, categories}: any) => {
  const {mode} = useThemeMode()

  if (series.length === 0 || categories.length === 0) {
    return <NoDataPage />
  }

  return (
    <>
      <div id='chart'>
        <ReactApexChart
          options={{
            chart: {
              height: 350,
              type: 'area',
              toolbar: {
                show: false,
              },
            },
            colors: ['#4776E6'],
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: 'smooth',
            },
            xaxis: {
              type: 'datetime',
              categories: categories,
              labels: {
                style: {
                  colors: mode === 'dark' ? '#ffffff' : '#000000', // Change X-axis labels color based on theme
                  fontSize: '12px',
                },
              },
            },
            yaxis: {
              tickAmount: 6,
              labels: {
                formatter: function (val: number) {
                  if (val >= 1000000000) return (val / 1000000000).toFixed(1) + 'B'
                  if (val >= 1000000) return (val / 1000000).toFixed(1) + 'M'
                  return val.toString()
                },
                style: {
                  colors: mode === 'dark' ? '#ffffff' : '#000000', // Change X-axis labels color based on theme
                  fontSize: '12px',
                },
              },
            },

            grid: {
              show: true,
              borderColor: mode === 'dark' ? '#565674' : '#DBDFE9',
              strokeDashArray: 0,
              position: 'back',
            },
          }}
          series={series}
          type='area'
          height={297}
        />
      </div>
      <div id='html-dist'></div>
    </>
  )
}

export default OverviewGraph
